/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Decrease_Font_Size_LabelInputs */



/**
* | output |
* | --- |
* | "Decrease font size" |
*
* @param {Audio_Recorder_Decrease_Font_Size_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_decrease_font_size_label = /** @type {((inputs?: Audio_Recorder_Decrease_Font_Size_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Decrease_Font_Size_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Diminuer la taille de la police")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schriftgröße verringern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Diminuisci la dimensione del carattere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Уменьшить размер шрифта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Disminuir el tamaño de la fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("减小字体大小")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォントサイズを小さくする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ॉन्ट का आकार घटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diminuir o tamanho da fonte")
	return /** @type {LocalizedString} */ ("Decrease font size")
});